interface AppConfig {
  API_BASE_URL: string;
  BUILD_TAG: string;
}

declare global {
  interface Window { __APP_CONFIG__?: Partial<AppConfig> }
}

export const config: AppConfig = {
  API_BASE_URL: window.__APP_CONFIG__?.API_BASE_URL ?? "/api",
  BUILD_TAG: window.__APP_CONFIG__?.BUILD_TAG ?? "unknown",
};

